<template>
  <div>
    <section class="goal">
      <h2>URLの操作</h2>
      <div class="wrap">
        <input :value="$route.query.text" @change="onChangeText" />
        <pre>{{ $route.query.text }}</pre>
      </div>
    </section>
    <hr class="border" />
    <p class="border_txt">これ以下は模写不要</p>
    <section class="question">
      <h2>問題</h2>
      <div class="wrap">
        <p class="question_txt">
          以上のアプリケーションを作成しなさい<br />
          <br />
          【注意】<br />
          URLにテキストが保存されている点に注意しなさい<br />
          リロードしてもデータがクリアされない点に注意しなさい<br />
        </p>
      </div>
    </section>
    <section class="answer">
      <h2>回答</h2>
      <div v-if="showAnswer">
        <button class="answer_btn" @click="showAnswer = false">
          回答を非表示
        </button>
        <div class="wrap">
          <pre>
            <code v-pre>
&lt;template&gt;
  &lt;div&gt;
    &lt;input :value="$route.query.text" @change="onChangeText" /&gt;
    &lt;pre&gt;{{ $route.query.text }}&lt;/pre&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  methods: {
    onChangeText(e) {
      if (e.target.value) {
        this.$router.push({ query: { text: e.target.value } });
      } else {
        this.$router.push({ path: this.$route.path });
      }
    },
    clearStorage() {
      localStorage.removeItem("text");
    },
  },
};
&lt;/script&gt;
            </code>
          </pre>
        </div>
      </div>
      <button v-else class="answer_btn" @click="showAnswer = true">
        回答を表示
      </button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      showAnswer: false,
    };
  },
  methods: {
    onChangeText(e) {
      if (e.target.value) {
        this.$router.push({ query: { text: e.target.value } });
      } else {
        this.$router.push({ path: this.$route.path });
      }
    },
    clearStorage() {
      localStorage.removeItem("text");
    },
  },
};
</script>
